export { default as DocumentMediasIcon } from './DocumentMediasIcon';
